const parseColor = color => {
    if (typeof color !== 'string') return null;
    const hex = color.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
    if (hex) {
        let value = hex[1];
        if (value.length === 3) {
            value = value
                .split('')
                .map(char => char + char)
                .join('');
        }
        const int = parseInt(value, 16);
        return { r: (int >> 16) & 255, g: (int >> 8) & 255, b: int & 255, a: 1 };
    }
    const rgb = color.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+)\s*)?\)$/i);
    if (rgb) {
        return { r: +rgb[1], g: +rgb[2], b: +rgb[3], a: rgb[4] !== undefined ? +rgb[4] : 1 };
    }
    return null;
};

export const withAlpha = (color, alpha) => {
    const parsed = parseColor(color);
    if (!parsed) return color;
    return `rgba(${parsed.r}, ${parsed.g}, ${parsed.b}, ${parsed.a * alpha})`;
};

const verticalGradient = (color, from, to) => context => {
    const { ctx, chartArea } = context.chart;
    if (!chartArea) return withAlpha(color, from);
    const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
    gradient.addColorStop(0, withAlpha(color, from));
    gradient.addColorStop(1, withAlpha(color, to));
    return gradient;
};

export const verticalBarGradient = (color, { from = 1, to = 0.88 } = {}) => verticalGradient(color, from, to);

export const areaGradient = (color, { from = 0.25, to = 0.02 } = {}) => verticalGradient(color, from, to);
